import SaleStore from './SaleStore';
import CampaignAI from './CampaignAI';
import React, { useState, useEffect, useRef } from "react";
import ListingTool from "./ListingTool";

// ─── CREDENTIALS ──────────────────────────────────────────────────────────────
// DB users loaded from API, fallback below
const FALLBACK_USERS = {
  user1:"Reports@123", user2:"Reports@123", user3:"Reports@123", admin:"Admin@Reports123"
};

// ─── MARKETPLACES ─────────────────────────────────────────────────────────────
const TOOLS = [
  {id:"amazon",    name:"Amazon Report",      icon:"📦", color:"#FF9900", tagline:"Sales, Ads & 9-sheet Report",   available:true},
  {id:"meesho",    name:"Meesho Report",      icon:"🛍️", color:"#F43397", tagline:"Daily Sales & State-wise",      available:true},
  {id:"state",     name:"State-wise Sales",   icon:"🗺️", color:"#27AE60", tagline:"Amazon + Meesho state analysis", available:true},
  {id:"keywords",  name:"Listing Keywords",   icon:"🔑", color:"#4A9FD4", tagline:"Search Term Extractor",          available:true},
  {id:"bulk",      name:"Bulk Optimizer",     icon:"⚡", color:"#B07FD4", tagline:"Smart bid recommendations",      available:true},
  {id:"overlap",   name:"Campaign Overlap",   icon:"🔄", color:"#E74C3C", tagline:"Duplicate campaigns & keywords", available:true},
  {id:"images",    name:"Image Manager",      icon:"🖼️", color:"#27AE60", tagline:"Upload, compress & share links", available:true},
  {id:"listing",   name:"Listing Generator",  icon:"✍️", color:"#F39C12", tagline:"AI-powered content creator",     available:true},
  {id:"audit",     name:"Listing Audit",      icon:"🔍", color:"#9B59B6", tagline:"AI content & image feedback",    available:true},
  {id:"flipkart",   name:"Flipkart Report",    icon:"🛒", color:"#2874F0", tagline:"Daily Sales Report",             available:true},
  {id:"marketplace",name:"Marketplace Compare", icon:"🏪", color:"#E67E22", tagline:"Amazon + Meesho + Flipkart SKU-wise",available:true},
  {id:"sku_econ",   name:"SKU Economics",       icon:"💰", color:"#2E86C1", tagline:"Monthly P&L per SKU",             available:true},
  {id:"sales",      name:"Sales Data",          icon:"💾", color:"#16A085", tagline:"Store & download by date range",  available:true},
  {id:"campaign_ai",name:"Campaign AI",         icon:"🤖", color:"#9B59B6", tagline:"Audit, harvest & optimise",        available:true},
];

// Mobile breakpoint helper
const isMobile = () => window.innerWidth < 768;

const S = {
  root:{minHeight:"100vh",background:"#0a0f1e",color:"#e8edf5",fontFamily:"'DM Sans',sans-serif",position:"relative"},
  gridBg:{position:"fixed",inset:0,pointerEvents:"none",backgroundImage:"linear-gradient(rgba(255,255,255,0.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.02) 1px,transparent 1px)",backgroundSize:"48px 48px"},
  wrap:{maxWidth:1200,margin:"0 auto",padding:"clamp(16px,4vw,40px) clamp(12px,3vw,24px)",position:"relative"},
  mobileGrid:{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:12},
  btn:{color:"#fff",border:"none",borderRadius:10,padding:"12px 28px",fontSize:14,fontWeight:600,cursor:"pointer"},
  ghost:{background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,color:"#aabbcc",cursor:"pointer",fontSize:12,padding:"7px 14px"},
  input:{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:8,padding:"10px 14px",color:"#e8edf5",fontSize:14,outline:"none",boxSizing:"border-box"},
  card:{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,padding:"18px"},
};

// ─── LOGIN ─────────────────────────────────────────────────────────────────────
function LoginPage({onLogin}) {
  const [u,setU]=useState(""); const [p,setP]=useState(""); const [err,setErr]=useState(""); const [loading,setLoading]=useState(false);
  const submit = async () => {
    setLoading(true); setErr("");
    try {
      const r = await fetch("/api/auth/login",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({username:u,password:p})});
      const d = await r.json();
      if (d.ok) { onLogin(d); }
      else {
        // fallback local check
        if (FALLBACK_USERS[u]===p) onLogin({username:u,role:u==="admin"?"admin":"user",token:"local",dbMode:"lite",toolAccess:null});
        else setErr(d.error||"Invalid credentials");
      }
    } catch(_) {
      if (FALLBACK_USERS[u]===p) onLogin({username:u,role:u==="admin"?"admin":"user",token:"local",dbMode:"lite",toolAccess:null});
      else setErr("Login failed");
    }
    setLoading(false);
  };
  return (
    <div style={{...S.root,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:16,padding:"40px 36px",width:"100%",maxWidth:380,textAlign:"center"}}>
        <div style={{fontSize:44,marginBottom:12}}>📊</div>
        <h2 style={{color:"#e8edf5",fontSize:22,fontWeight:700,margin:"0 0 6px"}}>Report Generator</h2>
        <p style={{color:"#667788",fontSize:14,margin:"0 0 28px"}}>Sign in to continue</p>
        <div style={{textAlign:"left",marginBottom:16}}>
          <label style={{display:"block",color:"#8899aa",fontSize:13,marginBottom:6}}>Username</label>
          <input style={S.input} type="text" placeholder="e.g. user1" value={u} onChange={e=>{setU(e.target.value);setErr("");}} onKeyDown={e=>e.key==="Enter"&&submit()}/>
        </div>
        <div style={{textAlign:"left",marginBottom:20}}>
          <label style={{display:"block",color:"#8899aa",fontSize:13,marginBottom:6}}>Password</label>
          <input style={S.input} type="password" placeholder="••••••••" value={p} onChange={e=>{setP(e.target.value);setErr("");}} onKeyDown={e=>e.key==="Enter"&&submit()}/>
        </div>
        {err&&<div style={{color:"#FF6B6B",fontSize:13,background:"rgba(255,107,107,0.1)",borderRadius:8,padding:"8px 12px",marginBottom:16}}>{err}</div>}
        <button style={{...S.btn,width:"100%",background:"linear-gradient(135deg,#1F4E79,#4A9FD4)",opacity:loading?0.7:1}} onClick={submit} disabled={loading}>
          {loading?"⟳ Signing in...":"Sign In"}
        </button>
      </div>
    </div>
  );
}

// ─── DASHBOARD ─────────────────────────────────────────────────────────────────
function Dashboard({session,onSelect,onLogout}) {
  const [usage,setUsage]=useState(null);
  useEffect(()=>{
    fetch(`/api/usage/${session.username}`).then(r=>r.json()).then(setUsage).catch(()=>{});
  },[session.username]);

  const isAdmin = session.role==="admin";
  const visibleTools = TOOLS.filter(t=>isAdmin||!t.adminOnly);

  return (
    <div style={S.root}>
      <div style={S.gridBg}/>
      <div style={S.wrap}>
        <header style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:40}}>
          <div>
            <div style={{display:"inline-block",padding:"5px 14px",borderRadius:20,background:"rgba(74,159,212,0.15)",border:"1px solid rgba(74,159,212,0.3)",color:"#4A9FD4",fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase"}}>
              {session.dbMode==="full"?"🟢 Full Mode — Database Connected":"🟡 Lite Mode — No Database"}
            </div>
            <h1 style={{color:"#e8edf5",fontSize:24,fontWeight:800,margin:"10px 0 0"}}>
              Welcome back, <span style={{background:"linear-gradient(135deg,#4A9FD4,#B07FD4)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>{session.username}</span>
              {isAdmin&&<span style={{marginLeft:8,fontSize:13,color:"#E74C3C",fontWeight:600}}>👑 Admin</span>}
            </h1>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            {isAdmin&&<button style={{...S.ghost,color:"#E74C3C",borderColor:"rgba(231,76,60,0.3)"}} onClick={()=>onSelect("admin")}>⚙️ Admin Panel</button>}
            <button style={S.ghost} onClick={onLogout}>Sign out</button>
          </div>
        </header>

        {/* Usage strip */}
        {usage?.total?.calls>0&&(
          <div style={{background:"rgba(39,174,96,0.08)",border:"1px solid rgba(39,174,96,0.2)",borderRadius:10,padding:"10px 16px",marginBottom:28,display:"flex",gap:24,alignItems:"center",flexWrap:"wrap"}}>
            <span style={{color:"#27AE60",fontWeight:700,fontSize:13}}>📊 Your AI Usage</span>
            <span style={{color:"#aabbcc",fontSize:12}}>Calls: <strong style={{color:"#e8edf5"}}>{usage.total.calls}</strong></span>
            <span style={{color:"#aabbcc",fontSize:12}}>Tokens: <strong style={{color:"#e8edf5"}}>{((usage.total.ti||0)+(usage.total.to2||0)).toLocaleString()}</strong></span>
            <span style={{color:"#aabbcc",fontSize:12}}>Cost: <strong style={{color:"#F39C12"}}>₹{parseFloat(usage.total.cost||0).toFixed(4)}</strong></span>
          </div>
        )}

        <h2 style={{color:"#e8edf5",fontSize:18,fontWeight:700,marginBottom:8}}>Select Tool</h2>
        <p style={{color:"#667788",fontSize:13,marginBottom:24}}>Choose a tool to get started</p>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:14}}>
          {visibleTools.filter(t=>{
            if(!t.available) return true;
            if(!session.toolAccess) return true;
            try{ const a=JSON.parse(session.toolAccess); return !a.length||a.includes(t.id); }catch(_){return true;}
          }).map(t=>(
            <div key={t.id} onClick={()=>t.available&&onSelect(t.id)}
              style={{background:`${t.color}10`,border:`1px solid ${t.available?t.color+"33":"rgba(255,255,255,0.06)"}`,borderRadius:14,padding:"20px 16px",textAlign:"center",cursor:t.available?"pointer":"not-allowed",opacity:t.available?1:0.5,transition:"transform 0.15s"}}>
              <div style={{fontSize:32,marginBottom:10}}>{t.icon}</div>
              <div style={{color:"#e8edf5",fontSize:14,fontWeight:700,marginBottom:4}}>{t.name}</div>
              <div style={{color:"#8899aa",fontSize:11,marginBottom:14}}>{t.tagline}</div>
              <div style={{display:"inline-block",padding:"4px 12px",borderRadius:16,border:`1px solid ${t.available?t.color+"44":"rgba(255,255,255,0.08)"}`,background:t.available?t.color+"18":"rgba(255,255,255,0.04)",color:t.available?t.color:"#556677",fontSize:11,fontWeight:600}}>
                {t.available?"Open →":"Coming Soon"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── GENERIC TOOL PAGE ──────────────────────────────────────────────────────────
function ToolPage({title,badge,color,description,user,onBack,children}) {
  return (
    <div style={S.root}>
      <div style={S.gridBg}/>
      <div style={S.wrap}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <button style={S.ghost} onClick={onBack}>← Dashboard</button>
            <div style={{display:"inline-block",padding:"5px 14px",borderRadius:20,background:`${color}18`,border:`1px solid ${color}44`,color,fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase"}}>{badge}</div>
          </div>
          <span style={{color:"#8899aa",fontSize:13}}>👤 {user}</span>
        </div>
        <h1 style={{color:"#e8edf5",fontSize:22,fontWeight:800,margin:"0 0 6px"}}>{title}</h1>
        <p style={{color:"#8899aa",fontSize:13,marginBottom:24}}>{description}</p>
        {children}
      </div>
    </div>
  );
}

// ─── DROP ZONE ──────────────────────────────────────────────────────────────────
function DropZone({zone,fileList,onSelect,onRemove}) {
  const [drag,setDrag]=useState(false);
  return (
    <div style={{background:"rgba(255,255,255,0.03)",borderRadius:12,border:`1px solid ${drag?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.08)"}`,overflow:"hidden"}}>
      <div style={{height:3,background:zone.color}}/>
      <div style={{padding:14}}>
        <div style={{fontSize:22,marginBottom:4}}>{zone.icon}</div>
        <div style={{fontWeight:700,fontSize:13,marginBottom:2,color:"#e8edf5"}}>{zone.label}</div>
        <div style={{fontSize:11,color:"#667788",marginBottom:10}}>{zone.sub}</div>
        <label style={{display:"flex",flexDirection:"column",alignItems:"center",border:"2px dashed rgba(255,255,255,0.1)",borderRadius:8,padding:"12px 8px",cursor:"pointer",textAlign:"center",marginBottom:8}}
          onDragOver={e=>{e.preventDefault();setDrag(true);}} onDragLeave={()=>setDrag(false)}
          onDrop={e=>{e.preventDefault();setDrag(false);const f=Array.from(e.dataTransfer.files);if(onSelect)onSelect({target:{files:f}});}}>
          <input type="file" accept={zone.accept} multiple={zone.multiple} style={{display:"none"}} onChange={onSelect}/>
          <span style={{fontSize:11,color:"#aabbcc",marginBottom:2}}>{drag?"Drop here":"Click or drag"}</span>
          <span style={{fontSize:10,color:"#445566"}}>{zone.hint}</span>
        </label>
        {(fileList||[]).length>0&&(
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            {(fileList||[]).map((f,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(255,255,255,0.05)",borderRadius:5,padding:"4px 8px"}}>
                <span style={{fontSize:10,color:"#aaccdd",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:"85%"}}>{f.name}</span>
                <button style={{background:"none",border:"none",color:"#FF6B6B",cursor:"pointer",fontSize:13,padding:"0 2px"}} onClick={()=>onRemove&&onRemove(i)}>×</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function LogBox({log}) {
  if (!log.length) return null;
  return (
    <div style={{background:"rgba(0,0,0,0.4)",borderRadius:10,border:"1px solid rgba(255,255,255,0.06)",padding:"12px 16px",marginBottom:16,fontFamily:"monospace",fontSize:12}}>
      {log.map((l,i)=><div key={i} style={{marginBottom:3,color:l.type==="success"?"#4CAF82":l.type==="error"?"#FF6B6B":"#8BB8D4"}}>› {l.msg}</div>)}
    </div>
  );
}

// ─── AMAZON TOOL ────────────────────────────────────────────────────────────────
function AmazonTool({user,onBack}) {
  const [files,setFiles]=useState({orders:[],business:[],ads:[],campaign:[],searchterm:[]});
  const [status,setStatus]=useState("idle"); const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const ZONES=[
    {id:"orders",   label:"Order Files",        sub:".txt monthly exports",    accept:".txt",  multiple:true, icon:"📦",color:"#1F4E79",hint:"orders_jan.txt"},
    {id:"business", label:"Business Reports",   sub:"BusinessReport-DD-MM-YY.csv",accept:".csv",multiple:true,icon:"📊",color:"#1E5631",hint:"date in filename"},
    {id:"ads",      label:"Ads Product Report", sub:"Advertised product .xlsx",accept:".xlsx", multiple:true, icon:"📣",color:"#4A235A",hint:"Advertised_product_report.xlsx"},
    {id:"campaign", label:"Campaign Report",    sub:"Campaign .csv",           accept:".csv",  multiple:true, icon:"📈",color:"#7D3C98",hint:"Campaign_report.csv"},
    {id:"searchterm",label:"Search Term Report",sub:"Search term .xlsx",       accept:".xlsx", multiple:true, icon:"🔍",color:"#1A5276",hint:"Search_term_report.xlsx"},
  ];
  const total=Object.values(files).flat().length;
  const go=async()=>{
    if(!total)return; setStatus("loading"); setLog([]);
    addLog("Uploading files..."); const fd=new FormData();
    Object.entries(files).forEach(([k,arr])=>arr.forEach(f=>fd.append(k,f)));
    try{
      addLog("Processing data...");
      const res=await fetch("/api/generate",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      addLog("Building Excel...");
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="amazon_sales_report.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success"); setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  return (
    <ToolPage title="Amazon Report Generator" badge="📦 Amazon" color="#FF9900" description="Upload order, ads, campaign & search term files — get a 9-sheet Excel report." user={user} onBack={onBack}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
        {ZONES.slice(0,3).map(z=><DropZone key={z.id} zone={z} fileList={files[z.id]} onSelect={e=>{const f=Array.from(e.target.files||e);setFiles(p=>({...p,[z.id]:[...p[z.id],...f]}));}} onRemove={i=>setFiles(p=>({...p,[z.id]:p[z.id].filter((_,j)=>j!==i)}))}/>)}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:20}}>
        {ZONES.slice(3).map(z=><DropZone key={z.id} zone={z} fileList={files[z.id]} onSelect={e=>{const f=Array.from(e.target.files||e);setFiles(p=>({...p,[z.id]:[...p[z.id],...f]}));}} onRemove={i=>setFiles(p=>({...p,[z.id]:p[z.id].filter((_,j)=>j!==i)}))}/>)}
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#1F4E79,#4A9FD4)",...(!total||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!total||status==="loading"}>
          {status==="loading"?"⟳ Generating...":"⬇ Generate Report"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles({orders:[],business:[],ads:[],campaign:[],searchterm:[]});setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── MEESHO TOOL ────────────────────────────────────────────────────────────────
function MeeshoTool({user,onBack}) {
  const [files,setFiles]=useState([]);const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const go=async()=>{
    if(!files.length)return;setStatus("loading");setLog([]);addLog("Processing Meesho orders...");
    const fd=new FormData(); files.forEach(f=>fd.append("meesho",f));
    try{
      const res=await fetch("/api/meesho",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="meesho_sales_report.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const zone={label:"Meesho Order CSV",sub:"Orders export .csv",accept:".csv",multiple:true,icon:"🛍️",color:"#F43397",hint:"Orders_YYYY-MM-DD.csv"};
  return (
    <ToolPage title="Meesho Sales Report" badge="🛍️ Meesho" color="#F43397" description="Upload Meesho order CSV files — get Daily Sales × SKU report with State-wise breakdown." user={user} onBack={onBack}>
      <div style={{maxWidth:400,marginBottom:20}}>
        <DropZone zone={zone} fileList={files} onSelect={e=>{setFiles(p=>[...p,...Array.from(e.target.files||e)]);}} onRemove={i=>setFiles(p=>p.filter((_,j)=>j!==i))}/>
      </div>
      <div style={{background:"rgba(244,51,151,0.08)",border:"1px solid rgba(244,51,151,0.2)",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#f48fb1"}}>
        📋 Output: <strong>Sheet 1</strong> — Daily SKU × Date (Units, Total Sales, Discounted Sales, AOV, Ad Orders, Organic, Ad%) · <strong>Sheet 2</strong> — State-wise Summary
        <br/>✅ Includes: Shipped, Delivered, Ready to Ship only
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#7B0A4E,#F43397)",...(!files.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!files.length||status==="loading"}>
          {status==="loading"?"⟳ Processing...":"⬇ Generate Report"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles([]);setZipFile(null);setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── STATE SALES TOOL ───────────────────────────────────────────────────────────
function StateTool({user,onBack}) {
  const [amazon,setAmazon]=useState([]);const [meesho,setMeesho]=useState([]);const [flipkart,setFlipkart]=useState([]);
  const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const z3={label:"Flipkart Report",sub:"earn_more_report .xlsx",accept:".xlsx",multiple:true,icon:"🛒",color:"#2874F0",hint:"Flipkart_report.xlsx"};
  const go=async()=>{
    if(!amazon.length&&!meesho.length&&!flipkart.length)return;setStatus("loading");setLog([]);addLog("Analysing state-wise sales...");
    const fd=new FormData(); amazon.forEach(f=>fd.append("amazon",f)); meesho.forEach(f=>fd.append("meesho",f)); flipkart.forEach(f=>fd.append("flipkart",f));
    try{
      const res=await fetch("/api/state-sales",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="state_sales_report.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const z1={label:"Amazon Orders",sub:".txt order exports",accept:".txt",multiple:true,icon:"📦",color:"#FF9900",hint:"orders_jan.txt"};
  const z2={label:"Meesho Orders",sub:"Order CSV files",accept:".csv",multiple:true,icon:"🛍️",color:"#F43397",hint:"Orders_YYYY-MM-DD.csv"};
  return (
    <ToolPage title="State-wise Sales" badge="🗺️ States" color="#27AE60" description="Upload Amazon orders and/or Meesho CSV files to get state-wise sales breakdown." user={user} onBack={onBack}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20,maxWidth:900}}>
        <DropZone zone={z1} fileList={amazon} onSelect={e=>setAmazon(p=>[...p,...Array.from(e.target.files||e)])} onRemove={i=>setAmazon(p=>p.filter((_,j)=>j!==i))}/>
        <DropZone zone={z2} fileList={meesho} onSelect={e=>setMeesho(p=>[...p,...Array.from(e.target.files||e)])} onRemove={i=>setMeesho(p=>p.filter((_,j)=>j!==i))}/>
        <DropZone zone={z3} fileList={flipkart} onSelect={e=>setFlipkart(p=>[...p,...Array.from(e.target.files||e)])} onRemove={i=>setFlipkart(p=>p.filter((_,j)=>j!==i))}/>
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#1E8449,#27AE60)",...((!amazon.length&&!meesho.length&&!flipkart.length)||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={(!amazon.length&&!meesho.length&&!flipkart.length)||status==="loading"}>
          {status==="loading"?"⟳ Analysing...":"⬇ Generate Report"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setAmazon([]);setMeesho([]);setFlipkart([]);setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── KEYWORDS TOOL ──────────────────────────────────────────────────────────────
function KeywordsTool({user,onBack}) {
  const [files,setFiles]=useState({searchterm:[],ads:[]});const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const go=async()=>{
    if(!files.searchterm.length)return;setStatus("loading");setLog([]);addLog("Analysing search terms...");
    const fd=new FormData();files.searchterm.forEach(f=>fd.append("searchterm",f));files.ads.forEach(f=>fd.append("ads",f));
    try{
      const res=await fetch("/api/keywords",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="listing_keywords.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const ZONES=[
    {id:"searchterm",label:"Search Term Report",sub:"Required .xlsx",accept:".xlsx",multiple:true,icon:"🔍",color:"#1A5276",hint:"Search_term_report.xlsx"},
    {id:"ads",label:"Ads Product Report",sub:"Optional .xlsx",accept:".xlsx",multiple:true,icon:"📣",color:"#4A235A",hint:"Advertised_product_report.xlsx"},
  ];
  return (
    <ToolPage title="Listing Keyword Extractor" badge="🔑 Keywords" color="#4A9FD4" description="Extract converting keywords from search term report for your listing." user={user} onBack={onBack}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20,maxWidth:700}}>
        {ZONES.map(z=><DropZone key={z.id} zone={z} fileList={files[z.id]} onSelect={e=>{const f=Array.from(e.target.files||e);setFiles(p=>({...p,[z.id]:[...p[z.id],...f]}));}} onRemove={i=>setFiles(p=>({...p,[z.id]:p[z.id].filter((_,j)=>j!==i)}))}/>)}
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#1A5276,#4A9FD4)",...(!files.searchterm.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!files.searchterm.length||status==="loading"}>
          {status==="loading"?"⟳ Extracting...":"⬇ Extract Keywords"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles({searchterm:[],ads:[]});setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── BULK OPTIMIZER TOOL ────────────────────────────────────────────────────────
function BulkTool({user,session,onBack}) {
  const [files,setFiles]=useState({bulk:[],ads:[],orders:[]});const [targetAcos,setTargetAcos]=useState("20");
  const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  useEffect(()=>{ fetch(`/api/settings/${user}`).then(r=>r.json()).then(d=>setTargetAcos(String(d.targetAcos||20))).catch(()=>{}); },[user]);
  const go=async()=>{
    if(!files.bulk.length||!files.ads.length)return;setStatus("loading");setLog([]);addLog("Optimising bids...");
    const fd=new FormData();files.bulk.forEach(f=>fd.append("bulk",f));files.ads.forEach(f=>fd.append("ads",f));files.orders.forEach(f=>fd.append("orders",f));fd.append("targetAcos",targetAcos);fd.append("username",user);
    try{
      const res=await fetch("/api/bulk-optimize",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="bulk_optimized.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const ZONES=[
    {id:"bulk",label:"Bulk Sheet",sub:"Amazon Bulk Sheet .xlsx",accept:".xlsx",multiple:false,icon:"⚡",color:"#7D3C98",hint:"Bulk_Sheet.xlsx"},
    {id:"ads",label:"Ads Product Report",sub:"Advertised product .xlsx",accept:".xlsx",multiple:true,icon:"📣",color:"#4A235A",hint:"Advertised_product_report.xlsx"},
    {id:"orders",label:"Order Files",sub:"For TACoS .txt",accept:".txt",multiple:true,icon:"📦",color:"#1F4E79",hint:"orders_jan.txt"},
  ];
  return (
    <ToolPage title="Bulk Sheet Optimizer" badge="⚡ Bulk" color="#B07FD4" description="Smart bid recommendations based on target ACOS." user={user} onBack={onBack}>
      <div style={{background:"rgba(176,127,212,0.1)",border:"1px solid rgba(176,127,212,0.25)",borderRadius:12,padding:"14px 18px",marginBottom:20,maxWidth:500}}>
        <label style={{display:"block",color:"#c9a8f0",fontSize:13,fontWeight:600,marginBottom:8}}>🎯 Target ACOS (%)</label>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <input type="number" min="1" max="100" value={targetAcos} onChange={e=>setTargetAcos(e.target.value)}
            style={{...S.input,width:90,textAlign:"center",fontSize:18,fontWeight:700,color:"#B07FD4"}}/>
          <span style={{color:"#8899aa",fontSize:12}}>Above {Math.round(parseFloat(targetAcos)*1.5||30)}% → reduce · Below {Math.round(parseFloat(targetAcos)*0.7||14)}% → scale</span>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
        {ZONES.map(z=><DropZone key={z.id} zone={z} fileList={files[z.id]} onSelect={e=>{const f=Array.from(e.target.files||e);setFiles(p=>({...p,[z.id]:z.id==="bulk"?[f[0]]:[...p[z.id],...f]}));}} onRemove={i=>setFiles(p=>({...p,[z.id]:p[z.id].filter((_,j)=>j!==i)}))}/>)}
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#4A235A,#B07FD4)",...(!files.bulk.length||!files.ads.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!files.bulk.length||!files.ads.length||status==="loading"}>
          {status==="loading"?"⟳ Optimising...":"⚡ Optimise & Download"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles({bulk:[],ads:[],orders:[]});setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── OVERLAP TOOL ───────────────────────────────────────────────────────────────
function OverlapTool({user,onBack}) {
  const [files,setFiles]=useState({searchterm:[],ads:[],bulk:[]});const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const go=async()=>{
    if(!files.searchterm.length)return;setStatus("loading");setLog([]);addLog("Analysing campaign overlap...");
    const fd=new FormData();files.searchterm.forEach(f=>fd.append("searchterm",f));files.ads.forEach(f=>fd.append("ads",f));files.bulk.forEach(f=>fd.append("bulk",f));
    try{
      const res=await fetch("/api/overlap",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="campaign_overlap.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const ZONES=[
    {id:"searchterm",label:"Search Term Report",sub:"Required .xlsx",accept:".xlsx",multiple:true,icon:"🔍",color:"#1A5276",hint:"Search_term_report.xlsx"},
    {id:"ads",label:"Ads Product Report",sub:"Recommended .xlsx",accept:".xlsx",multiple:true,icon:"📣",color:"#4A235A",hint:"Advertised_product_report.xlsx"},
    {id:"bulk",label:"Bulk Sheet",sub:"Optional .xlsx",accept:".xlsx",multiple:false,icon:"⚡",color:"#7D3C98",hint:"Bulk_Sheet.xlsx"},
  ];
  return (
    <ToolPage title="Campaign Overlap Checker" badge="🔄 Overlap" color="#E74C3C" description="Find products and keywords running in multiple campaigns." user={user} onBack={onBack}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
        {ZONES.map(z=><DropZone key={z.id} zone={z} fileList={files[z.id]} onSelect={e=>{const f=Array.from(e.target.files||e);setFiles(p=>({...p,[z.id]:z.id==="bulk"?[f[0]]:[...p[z.id],...f]}));}} onRemove={i=>setFiles(p=>({...p,[z.id]:p[z.id].filter((_,j)=>j!==i)}))}/>)}
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#922B21,#E74C3C)",...(!files.searchterm.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!files.searchterm.length||status==="loading"}>
          {status==="loading"?"⟳ Analysing...":"🔄 Check Overlap"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles({searchterm:[],ads:[],bulk:[]});setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── IMAGE TOOL ─────────────────────────────────────────────────────────────────
function ImageTool({user,onBack}) {
  const [tab,setTab]=useState("upload");
  const [files,setFiles]=useState([]);const [zipFile,setZipFile]=useState(null);const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const [library,setLibrary]=useState({rows:[],total:0});const [search,setSearch]=useState("");const [page,setPage]=useState(1);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);

  useEffect(()=>{ if(tab==="library") fetchLib(); },[tab,search,page]);
  const fetchLib=async()=>{ try{ const r=await fetch(`/api/images?search=${encodeURIComponent(search)}&page=${page}`); const d=await r.json(); setLibrary(d); }catch(_){} };

  const grouped=()=>{ const m=new Map(); for(const f of files){ const parts=f.webkitRelativePath?f.webkitRelativePath.split("/"):[f.name]; const sku=parts.length>1?parts[parts.length-2]:"UNKNOWN"; if(!m.has(sku))m.set(sku,[]); m.get(sku).push(f); } return m; };

  const go=async()=>{
    if(!files.length&&!zipFile)return;setStatus("loading");setLog([]);
    const fd=new FormData();

    if(zipFile){
      addLog("Uploading ZIP file...");
      fd.append("zipfile",zipFile);
      fd.append("username",user);fd.append("baseUrl",`${window.location.origin}/images`);
      try{
        const res=await fetch("/api/images/upload-zip",{method:"POST",body:fd});
        if(!res.ok){const e=await res.json();throw new Error(e.error);}
        addLog("Building Excel with links...");
        const blob=await res.blob();const url=URL.createObjectURL(blob);
        const a=document.createElement("a");a.href=url;a.download="image_links.xlsx";a.click();URL.revokeObjectURL(url);
        addLog("✅ Done!","success");setStatus("done");
      }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
      return;
    }

    const grp=grouped(); addLog(`Found ${grp.size} SKU folders, ${files.length} images total...`);
    const skuMap={};
    for(const [sku,imgs] of grp){
      const sorted=[...imgs].sort((a,b)=>a.name.localeCompare(b.name,undefined,{numeric:true}));
      sorted.forEach((img,idx)=>{ const uname=`${sku}__${img.name}`; fd.append("images",img,uname); skuMap[uname]=sku; skuMap[uname+"_num"]=idx+1; skuMap[uname+"_rel"]=img.webkitRelativePath||`${sku}/${img.name}`; });
    }
    fd.append("skuMap",JSON.stringify(skuMap));fd.append("username",user);fd.append("baseUrl",`${window.location.origin}/images`);
    try{
      addLog("Uploading & saving images...");
      const res=await fetch("/api/images/upload",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      addLog("Building Excel with links...");
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="image_links.xlsx";a.click();URL.revokeObjectURL(url);
      addLog(`✅ Done! ${files.length} images saved & Excel downloaded.`,"success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };

  const grp=grouped();
  return (
    <ToolPage title="Image Manager" badge="🖼️ Images" color="#27AE60" description="Upload SKU folders, save publicly for 30 days, get Excel with links." user={user} onBack={onBack}>
      <div style={{display:"flex",gap:8,marginBottom:24}}>
        {[["upload","⬆ Upload"],["library","📚 Library"]].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{padding:"7px 18px",borderRadius:20,border:"1px solid",cursor:"pointer",fontSize:13,fontWeight:600,background:tab===id?"rgba(39,174,96,0.2)":"rgba(255,255,255,0.04)",borderColor:tab===id?"#27AE60":"rgba(255,255,255,0.1)",color:tab===id?"#27AE60":"#8899aa"}}>{label}</button>
        ))}
      </div>

      {tab==="upload"&&(
        <>
          {/* Upload mode toggle */}
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            {[["folder","📁 Folder Upload"],["zip","📦 ZIP Upload"]].map(([id,label])=>(
              <button key={id} onClick={()=>{setUploadType&&setUploadType(id);setFiles([]);}}
                style={{padding:"7px 16px",borderRadius:16,border:"1px solid",cursor:"pointer",fontSize:12,fontWeight:600,
                  background:"rgba(39,174,96,0.1)",borderColor:"rgba(39,174,96,0.3)",color:"#27AE60"}}>
                {label}
              </button>
            ))}
          </div>
          <div style={{background:"rgba(39,174,96,0.06)",border:"2px dashed rgba(39,174,96,0.3)",borderRadius:14,padding:"28px",textAlign:"center",marginBottom:20}}>
            <div style={{fontSize:36,marginBottom:10}}>📁</div>
            <div style={{color:"#e8edf5",fontSize:15,fontWeight:600,marginBottom:4}}>Select SKU Folders or ZIP</div>
            <div style={{color:"#8899aa",fontSize:12,marginBottom:14}}>Folder: each subfolder = SKU · ZIP: same structure inside zip</div>
            <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
              <label style={{display:"inline-block",background:"rgba(39,174,96,0.2)",border:"1px solid rgba(39,174,96,0.4)",borderRadius:8,padding:"9px 22px",cursor:"pointer",color:"#27AE60",fontSize:13,fontWeight:600}}>
                <input type="file" accept="image/*" multiple webkitdirectory="" directory="" style={{display:"none"}} onChange={e=>setFiles(Array.from(e.target.files))}/>
                📁 Choose Folder
              </label>
              <label style={{display:"inline-block",background:"rgba(74,159,212,0.2)",border:"1px solid rgba(74,159,212,0.4)",borderRadius:8,padding:"9px 22px",cursor:"pointer",color:"#4A9FD4",fontSize:13,fontWeight:600}}>
                <input type="file" accept=".zip" style={{display:"none"}} onChange={e=>setZipFile(e.target.files[0])}/>
                📦 Upload ZIP
              </label>
            </div>
            {zipFile&&<div style={{color:"#4A9FD4",fontSize:12,marginTop:8}}>📦 {zipFile.name}</div>}
          </div>
          {grp.size>0&&(
            <div style={{marginBottom:20}}>
              <div style={{color:"#e8edf5",fontSize:13,fontWeight:600,marginBottom:10}}>📦 {grp.size} SKUs · {files.length} images</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,maxHeight:200,overflowY:"auto"}}>
                {[...grp.entries()].map(([sku,imgs])=>(
                  <div key={sku} style={{background:"rgba(39,174,96,0.06)",border:"1px solid rgba(39,174,96,0.15)",borderRadius:8,padding:"10px"}}>
                    <div style={{color:"#27AE60",fontWeight:700,fontSize:12,marginBottom:2}}>{sku}</div>
                    <div style={{color:"#8899aa",fontSize:10}}>{imgs.length} image{imgs.length>1?"s":""}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
            <button style={{...S.btn,background:"linear-gradient(135deg,#1E8449,#27AE60)",...(!files.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!files.length||status==="loading"}>
              {status==="loading"?"⟳ Uploading...":"⬆ Upload & Save"}
            </button>
            {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles([]);setZipFile(null);setStatus("idle");setLog([]);}}>Start Over</button>}
          </div>
          <LogBox log={log}/>
        </>
      )}

      {tab==="library"&&(
        <>
          <div style={{display:"flex",gap:10,marginBottom:16,alignItems:"center"}}>
            <input style={{...S.input,flex:1,maxWidth:320}} placeholder="🔍 Search by SKU..." value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
            <button style={S.ghost} onClick={fetchLib}>Refresh</button>
            <span style={{color:"#667788",fontSize:13}}>{library.total} images</span>
          </div>
          {library.rows.length===0?(
            <div style={{textAlign:"center",color:"#667788",padding:40}}>No images found.</div>
          ):(
            <>
              {(()=>{ const skuGroups=new Map(); library.rows.forEach(r=>{ if(!skuGroups.has(r.sku))skuGroups.set(r.sku,[]); skuGroups.get(r.sku).push(r); });
                return [...skuGroups.entries()].map(([sku,imgs])=>(
                  <div key={sku} style={{marginBottom:16,background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.06)",borderRadius:10,overflow:"hidden"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:"rgba(39,174,96,0.08)",borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
                      <span style={{color:"#27AE60",fontWeight:700,fontSize:13}}>{sku}</span>
                      <div style={{display:"flex",gap:8,alignItems:"center"}}>
                        <span style={{color:"#667788",fontSize:11}}>{imgs.length} image{imgs.length>1?"s":""}</span>
                        <button onClick={async()=>{ if(!window.confirm(`Delete ALL images for ${sku}?`))return; await fetch(`/api/images/sku/${encodeURIComponent(sku)}`,{method:"DELETE"}); fetchLib(); }} style={{background:"rgba(231,76,60,0.15)",border:"1px solid rgba(231,76,60,0.3)",borderRadius:5,color:"#E74C3C",cursor:"pointer",fontSize:11,padding:"3px 9px"}}>🗑 Delete All</button>
                      </div>
                    </div>
                    {imgs.map(img=>(
                      <div key={img.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 14px",borderBottom:"1px solid rgba(255,255,255,0.03)"}}>
                        <img src={img.url} alt={img.filename} style={{width:44,height:44,objectFit:"cover",borderRadius:5,border:"1px solid rgba(255,255,255,0.1)",flexShrink:0,background:"#1a2030"}} onError={e=>e.target.style.display="none"}/>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{color:"#e8edf5",fontSize:11,fontWeight:600,marginBottom:2}}>{img.filename}</div>
                          <div style={{color:"#667788",fontSize:10}}>{img.file_size_kb}KB · {new Date(img.uploadedAt).toLocaleDateString("en-GB")} · <span style={{color:img.daysLeft<=3?"#E74C3C":img.daysLeft<=7?"#E67E22":"#27AE60"}}>{img.daysLeft}d left</span></div>
                        </div>
                        <div style={{display:"flex",gap:6,flexShrink:0}}>
                          <button onClick={()=>navigator.clipboard.writeText(img.url)} style={{background:"rgba(74,159,212,0.15)",border:"1px solid rgba(74,159,212,0.3)",borderRadius:5,color:"#4A9FD4",cursor:"pointer",fontSize:10,padding:"3px 8px"}}>📋 Copy</button>
                          <a href={img.url} target="_blank" rel="noreferrer" style={{background:"rgba(39,174,96,0.15)",border:"1px solid rgba(39,174,96,0.3)",borderRadius:5,color:"#27AE60",fontSize:10,padding:"3px 8px",textDecoration:"none"}}>🔗 Open</a>
                          <button onClick={async()=>{ await fetch(`/api/images/${img.filename}`,{method:"DELETE"}); fetchLib(); }} style={{background:"rgba(231,76,60,0.15)",border:"1px solid rgba(231,76,60,0.3)",borderRadius:5,color:"#E74C3C",cursor:"pointer",fontSize:10,padding:"3px 8px"}}>🗑</button>
                        </div>
                      </div>
                    ))}
                  </div>
                ));
              })()}
              {library.total>50&&(
                <div style={{display:"flex",justifyContent:"center",gap:10,marginTop:14}}>
                  <button style={S.ghost} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  <span style={{color:"#667788",fontSize:13,alignSelf:"center"}}>Page {page} of {Math.ceil(library.total/50)}</span>
                  <button style={S.ghost} disabled={page>=Math.ceil(library.total/50)} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              )}
            </>
          )}
        </>
      )}
    </ToolPage>
  );
}

// ─── LISTING AUDIT TOOL ─────────────────────────────────────────────────────────
function AuditTool({user,onBack}) {
  const [listings,setListings]=useState(Array(10).fill(null).map((_,i)=>({id:i,sku:"",url:"",imageLink:""})));
  const [results,setResults]=useState([]);const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);const [selIdx,setSelIdx]=useState(null);
  const [excelData,setExcelData]=useState(null);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const fileRef=useRef();

  const handleExcel=async(e)=>{
    const file=e.target.files[0]; if(!file)return;
    const fd=new FormData(); fd.append("listing",file);
    try{
      const r=await fetch("/api/listing/parse",{method:"POST",body:fd});
      const d=await r.json();
      if(d.ok&&d.rows.length){
        setExcelData(d.rows);
        setListings(d.rows.map((r,i)=>({id:i,sku:r.sku,url:"",imageLink:"",title:r.title,bp1:r.bp1,bp2:r.bp2,bp3:r.bp3,bp4:r.bp4,bp5:r.bp5,description:r.description})));
        addLog(`Loaded ${d.rows.length} SKUs from Excel`,"success");
      }
    }catch(e){addLog("Failed to read Excel: "+e.message,"error");}
  };

  const updateListing=(idx,field,val)=>setListings(p=>p.map((l,i)=>i===idx?{...l,[field]:val}:l));

  const auditOne=async(idx)=>{
    const listing=listings[idx]; if(!listing.sku)return;
    setStatus("loading");
    const toAudit=[listing];
    let imageUrls=[];
    if(listing.imageLink){imageUrls=[listing.imageLink];}
    else if(listing.sku){try{const r=await fetch(`/api/images?search=${encodeURIComponent(listing.sku)}`);const d=await r.json();imageUrls=(d.rows||[]).filter(img=>img.sku===listing.sku).map(img=>img.url);}catch(_){}}
    try{
      const res=await fetch("/api/listing/audit",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({listings:[{...listing,imageUrls}],username:user})});
      const d=await res.json();
      if(!d.ok)throw new Error(d.error);
      const newResults=[...results]; newResults[idx]=d.results[0]; setResults(newResults);
      setSelIdx(idx); setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("idle");}
  };

  const auditAll=async()=>{
    const toAudit=listings.filter(l=>l.sku);
    if(!toAudit.length)return;
    setStatus("loading");setLog([]);addLog(`Auditing ${toAudit.length} listings...`);
    const withImages=await Promise.all(listings.map(async(l,i)=>{
      if(!l.sku)return{...l,imageUrls:[]};
      let imageUrls=l.imageLink?[l.imageLink]:[];
      if(!imageUrls.length){try{const r=await fetch(`/api/images?search=${encodeURIComponent(l.sku)}`);const d=await r.json();imageUrls=(d.rows||[]).filter(img=>img.sku===l.sku).map(img=>img.url);}catch(_){}}
      return{...l,imageUrls};
    }));
    try{
      const res=await fetch("/api/listing/audit",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({listings:withImages.filter(l=>l.sku),username:user})});
      const d=await res.json();
      if(!d.ok)throw new Error(d.error);
      // Map results back by SKU
      const resultMap=new Map(d.results.map(r=>[r.sku,r]));
      setResults(listings.map(l=>resultMap.get(l.sku)||null));
      setSelIdx(listings.findIndex(l=>l.sku));
      addLog(`✅ Audited ${d.results.length} listings`,"success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("idle");}
  };

  const downloadResults=async()=>{
    const rows=listings.filter(l=>l.sku).map((l,i)=>{
      const r=results[listings.indexOf(l)]||{};
      return{...l,...r};
    });
    const fd=new FormData(); fd.append("rows",JSON.stringify(rows));
    const res=await fetch("/api/listing/download",{method:"POST",body:fd});
    const blob=await res.blob();const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download="audit_results.xlsx";a.click();URL.revokeObjectURL(url);
  };

  const scoreColor=(s)=>!s?"":(s>=8?"#27AE60":s>=6?"#F39C12":"#E74C3C");
  const sel=selIdx!==null?results[selIdx]:null;
  const doneCount=results.filter(Boolean).length;

  return (
    <ToolPage title="Listing Audit Tool" badge="🔍 Audit" color="#9B59B6" description="Upload your listing Excel or enter SKUs manually — AI audits content quality, keywords and images." user={user} onBack={onBack}>
      
      {/* Upload + Actions bar */}
      <div style={{display:"flex",gap:10,marginBottom:20,alignItems:"center",flexWrap:"wrap"}}>
        <label style={{background:"rgba(155,89,182,0.15)",border:"1px solid rgba(155,89,182,0.3)",borderRadius:8,padding:"8px 16px",cursor:"pointer",color:"#c9a8f0",fontSize:12,fontWeight:600}}>
          <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}} onChange={handleExcel}/>
          📋 Upload Listing Excel
        </label>
        <button style={{...S.btn,background:"linear-gradient(135deg,#6C3483,#9B59B6)",padding:"9px 20px",fontSize:12}} onClick={auditAll} disabled={status==="loading"}>
          {status==="loading"?"⟳ Auditing...":"🔍 Audit All"}
        </button>
        {doneCount>0&&(
          <button style={{...S.btn,background:"linear-gradient(135deg,#1E8449,#27AE60)",padding:"9px 20px",fontSize:12}} onClick={downloadResults}>
            ⬇ Download Excel
          </button>
        )}
        {doneCount>0&&<span style={{color:"#27AE60",fontSize:12,fontWeight:600}}>{doneCount}/{listings.filter(l=>l.sku).length} audited</span>}
      </div>

      <LogBox log={log}/>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        {/* Left: SKU table */}
        <div style={S.card}>
          <div style={{color:"#e8edf5",fontWeight:700,fontSize:13,marginBottom:12}}>Listings ({listings.filter(l=>l.sku).length} SKUs)</div>
          <div style={{display:"flex",flexDirection:"column",gap:6,maxHeight:480,overflowY:"auto"}}>
            {listings.map((l,i)=>{
              const r=results[i];
              return (
                <div key={i} onClick={()=>r&&setSelIdx(i)}
                  style={{display:"grid",gridTemplateColumns:"1fr 1fr auto auto",gap:6,padding:"6px 8px",borderRadius:8,background:selIdx===i?"rgba(155,89,182,0.1)":"rgba(255,255,255,0.02)",border:selIdx===i?"1px solid rgba(155,89,182,0.3)":"1px solid rgba(255,255,255,0.05)",cursor:r?"pointer":"default"}}>
                  <input style={{...S.input,fontSize:11,padding:"4px 8px"}} placeholder="SKU" value={l.sku} onChange={e=>updateListing(i,"sku",e.target.value)}/>
                  <input style={{...S.input,fontSize:11,padding:"4px 8px"}} placeholder="Image URL (optional)" value={l.imageLink} onChange={e=>updateListing(i,"imageLink",e.target.value)}/>
                  <button onClick={e=>{e.stopPropagation();auditOne(i);}} style={{background:"rgba(155,89,182,0.2)",border:"1px solid rgba(155,89,182,0.3)",borderRadius:6,color:"#c9a8f0",cursor:"pointer",fontSize:10,padding:"4px 8px",whiteSpace:"nowrap"}}>Audit</button>
                  {r&&<span style={{color:scoreColor(r.overallScore),fontWeight:700,fontSize:13,alignSelf:"center"}}>{r.overallScore}/10</span>}
                </div>
              );
            })}
          </div>
        </div>

        {/* Right: Result detail */}
        <div>
          {!sel?(
            <div style={{...S.card,textAlign:"center",padding:"48px 20px"}}>
              <div style={{fontSize:36,marginBottom:10}}>🔍</div>
              <div style={{color:"#8899aa",fontSize:13}}>Audit a listing to see detailed feedback</div>
            </div>
          ):(
            <div style={S.card}>
              {sel.error?(
                <div style={{color:"#FF6B6B",fontSize:12}}>❌ {sel.error}</div>
              ):(
                <>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:14,paddingBottom:12,borderBottom:"1px solid rgba(255,255,255,0.07)"}}>
                    <div style={{color:"#9B59B6",fontWeight:800,fontSize:15}}>{sel.sku}</div>
                    <div style={{fontSize:26,fontWeight:800,color:scoreColor(sel.overallScore)}}>{sel.overallScore}/10</div>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                    {[["Title",sel.titleScore,sel.titleFeedback],["Bullets",sel.bulletScore,sel.bulletFeedback],["Description",sel.descriptionScore,sel.descriptionFeedback],["Images",sel.imageScore,sel.imageFeedback],["Keywords",sel.keywordScore,sel.keywordFeedback]].map(([label,score,feedback])=>(
                      <div key={label} style={{background:"rgba(255,255,255,0.03)",border:`1px solid ${scoreColor(score)}33`,borderRadius:8,padding:"8px 10px"}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                          <span style={{color:"#e8edf5",fontSize:11,fontWeight:600}}>{label}</span>
                          <span style={{color:scoreColor(score),fontWeight:700,fontSize:12}}>{score}/10</span>
                        </div>
                        <div style={{color:"#aabbcc",fontSize:10,lineHeight:1.5}}>{feedback}</div>
                      </div>
                    ))}
                  </div>
                  {sel.topIssues?.length>0&&(
                    <div style={{background:"rgba(231,76,60,0.06)",border:"1px solid rgba(231,76,60,0.15)",borderRadius:8,padding:"8px 10px",marginBottom:8}}>
                      <div style={{color:"#E74C3C",fontWeight:600,fontSize:11,marginBottom:5}}>🔴 Top Issues</div>
                      {sel.topIssues.map((issue,i)=><div key={i} style={{color:"#aabbcc",fontSize:10,marginBottom:2}}>• {issue}</div>)}
                    </div>
                  )}
                  {sel.quickWins?.length>0&&(
                    <div style={{background:"rgba(39,174,96,0.06)",border:"1px solid rgba(39,174,96,0.15)",borderRadius:8,padding:"8px 10px"}}>
                      <div style={{color:"#27AE60",fontWeight:600,fontSize:11,marginBottom:5}}>✅ Quick Wins</div>
                      {sel.quickWins.map((win,i)=><div key={i} style={{color:"#aabbcc",fontSize:10,marginBottom:2}}>• {win}</div>)}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </ToolPage>
  );
}

// ─── FLIPKART TOOL ──────────────────────────────────────────────────────────────
function FlipkartTool({user,onBack}) {
  const [files,setFiles]=useState([]);const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const go=async()=>{
    if(!files.length)return;setStatus("loading");setLog([]);addLog("Processing Flipkart orders...");
    const fd=new FormData(); files.forEach(f=>fd.append("flipkart",f));
    try{
      const res=await fetch("/api/flipkart",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="flipkart_sales_report.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const zone={label:"Flipkart Sales Report",sub:"earn_more_report .xlsx",accept:".xlsx",multiple:true,icon:"🛒",color:"#2874F0",hint:"b6e8ebb5-...xlsx"};
  return (
    <ToolPage title="Flipkart Sales Report" badge="🛒 Flipkart" color="#2874F0" description="Upload Flipkart earn_more_report files — get Daily Final Units, Sales & AOV per SKU." user={user} onBack={onBack}>
      <div style={{maxWidth:400,marginBottom:20}}>
        <DropZone zone={zone} fileList={files} onSelect={e=>{setFiles(p=>[...p,...Array.from(e.target.files||e)]);}} onRemove={i=>setFiles(p=>p.filter((_,j)=>j!==i))}/>
      </div>
      <div style={{background:"rgba(40,116,240,0.08)",border:"1px solid rgba(40,116,240,0.2)",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#90CAF9",maxWidth:500}}>
        📋 Output: Daily SKU × Date — Final Units · Sales(₹) · AOV(₹)
        <br/>✅ Only Final Sale Units counted (after cancellations & returns)
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#1565C0,#2874F0)",...(!files.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={!files.length||status==="loading"}>
          {status==="loading"?"⟳ Processing...":"⬇ Generate Report"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles([]);setZipFile(null);setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}


// ─── SKU ECONOMICS TOOL ─────────────────────────────────────────────────────────
function SkuEconTool({user,onBack}) {
  const [econFiles,setEconFiles]=useState([]);
  const [listingsFile,setListingsFile]=useState(null);
  const [status,setStatus]=useState("idle");
  const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);

  const go=async()=>{
    if(!econFiles.length)return;setStatus("loading");setLog([]);
    addLog(`Processing ${econFiles.length} month(s) of SKU economics data...`);
    const fd=new FormData();
    econFiles.forEach(f=>fd.append("economics",f));
    if(listingsFile) fd.append("listings",listingsFile);
    try{
      addLog("Building summary and monthly sheets...");
      const res=await fetch("/api/sku-economics",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="Amazon_SKU_Economics_Summary.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };

  return (
    <ToolPage title="SKU Economics Report" badge="💰 SKU Economics" color="#2E86C1"
      description="Upload monthly SKU Economics CSV exports + All Listings Report to get a full P&L summary per SKU." user={user} onBack={onBack}>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20,maxWidth:800}}>
        {/* Economics files */}
        <div style={{...S.card,borderColor:"rgba(46,134,193,0.3)"}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
            <span style={{fontSize:20}}>📊</span>
            <div>
              <div style={{color:"#e8edf5",fontWeight:700,fontSize:14}}>SKU Economics CSV Files</div>
              <div style={{color:"#8899aa",fontSize:11}}>Required — one file per month</div>
            </div>
            <span style={{marginLeft:"auto",background:"rgba(231,76,60,0.2)",color:"#E74C3C",fontSize:10,padding:"2px 8px",borderRadius:10,fontWeight:600}}>Required</span>
          </div>
          <label style={{display:"flex",flexDirection:"column",alignItems:"center",border:"2px dashed rgba(46,134,193,0.3)",borderRadius:8,padding:"16px",cursor:"pointer",textAlign:"center",marginBottom:10}}>
            <input type="file" accept=".csv" multiple style={{display:"none"}} onChange={e=>setEconFiles(p=>[...p,...Array.from(e.target.files)])}/>
            <span style={{fontSize:12,color:"#5DADE2",fontWeight:600}}>Click to upload CSV files</span>
            <span style={{fontSize:10,color:"#8899aa",marginTop:3}}>Jan_2026.csv, Feb_2026.csv...</span>
          </label>
          {econFiles.length>0&&(
            <div>
              {econFiles.map((f,i)=>(
                <div key={i} style={{display:"flex",justifyContent:"space-between",background:"rgba(255,255,255,0.05)",borderRadius:5,padding:"4px 8px",marginBottom:3}}>
                  <span style={{fontSize:11,color:"#aaccdd"}}>{f.name}</span>
                  <button onClick={()=>setEconFiles(p=>p.filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:"#FF6B6B",cursor:"pointer",fontSize:13}}>×</button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Listings file */}
        <div style={S.card}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
            <span style={{fontSize:20}}>📋</span>
            <div>
              <div style={{color:"#e8edf5",fontWeight:700,fontSize:14}}>All Listings Report</div>
              <div style={{color:"#8899aa",fontSize:11}}>Optional — adds Product Title & Listing Price</div>
            </div>
            <span style={{marginLeft:"auto",background:"rgba(74,159,212,0.1)",color:"#4A9FD4",fontSize:10,padding:"2px 8px",borderRadius:10,fontWeight:600}}>Optional</span>
          </div>
          <label style={{display:"flex",flexDirection:"column",alignItems:"center",border:"2px dashed rgba(74,159,212,0.2)",borderRadius:8,padding:"16px",cursor:"pointer",textAlign:"center"}}>
            <input type="file" accept=".txt" style={{display:"none"}} onChange={e=>setListingsFile(e.target.files[0]||null)}/>
            <span style={{fontSize:12,color:"#4A9FD4",fontWeight:600}}>Click to upload</span>
            <span style={{fontSize:10,color:"#8899aa",marginTop:3}}>{listingsFile?listingsFile.name:"All_Listings_Report.txt"}</span>
          </label>
        </div>
      </div>

      <div style={{background:"rgba(46,134,193,0.08)",border:"1px solid rgba(46,134,193,0.2)",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#85C1E9",maxWidth:700}}>
        📋 Output: <strong>Monthly Summary sheet</strong> (all months side by side) + <strong>one sheet per month</strong> with ASIN, Title, Listing Price, AOV, Units, Sales, all Fees & Charges, Net Proceeds
      </div>

      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#1A5276,#2E86C1)",
          ...(!econFiles.length||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}}
          onClick={go} disabled={!econFiles.length||status==="loading"}>
          {status==="loading"?"⟳ Processing...":"💰 Generate Report"}
        </button>
        {(status==="done"||status==="error")&&(
          <button style={S.ghost} onClick={()=>{setEconFiles([]);setListingsFile(null);setStatus("idle");setLog([]);}}>Start Over</button>
        )}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}

// ─── MARKETPLACE TOOL ──────────────────────────────────────────────────────────
function MarketplaceTool({user,onBack}) {
  const [files,setFiles]=useState({amazon:[],meesho:[],flipkart:[]});
  const [status,setStatus]=useState("idle");const [log,setLog]=useState([]);
  const addLog=(msg,type="info")=>setLog(p=>[...p,{msg,type}]);
  const go=async()=>{
    if(!files.amazon.length&&!files.meesho.length)return;setStatus("loading");setLog([]);addLog("Comparing marketplace sales...");
    const fd=new FormData();files.amazon.forEach(f=>fd.append("amazon",f));files.meesho.forEach(f=>fd.append("meesho",f));files.flipkart.forEach(f=>fd.append("flipkart",f));
    try{
      const res=await fetch("/api/marketplace",{method:"POST",body:fd});
      if(!res.ok){const e=await res.json();throw new Error(e.error);}
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download="marketplace_comparison.xlsx";a.click();URL.revokeObjectURL(url);
      addLog("✅ Downloaded!","success");setStatus("done");
    }catch(e){addLog("❌ "+e.message,"error");setStatus("error");}
  };
  const ZONES=[
    {id:"amazon",  label:"Amazon Orders",  sub:".txt order exports",accept:".txt", multiple:true, icon:"📦",color:"#FF9900",hint:"orders_jan.txt"},
    {id:"meesho",  label:"Meesho Orders",  sub:"Order CSV files",   accept:".csv", multiple:true, icon:"🛍️",color:"#F43397",hint:"Orders_YYYY-MM-DD.csv"},
    {id:"flipkart",label:"Flipkart Report",sub:"earn_more_report .xlsx",accept:".xlsx",multiple:true,icon:"🛒",color:"#2874F0",hint:"Flipkart_report.xlsx"},
  ];
  return (
    <ToolPage title="Marketplace Comparison" badge="🏪 Compare" color="#E67E22" description="Upload Amazon and Meesho order files to compare SKU-wise Units, Sales and AOV across platforms." user={user} onBack={onBack}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:16,maxWidth:800}}>
        {ZONES.map(z=><DropZone key={z.id} zone={z} fileList={files[z.id]} onSelect={e=>{const f=Array.from(e.target.files||e);setFiles(p=>({...p,[z.id]:[...p[z.id],...f]}));}} onRemove={i=>setFiles(p=>({...p,[z.id]:p[z.id].filter((_,j)=>j!==i)}))}/>)}
      </div>
      <div style={{background:"rgba(230,126,34,0.08)",border:"1px solid rgba(230,126,34,0.2)",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#F0B27A",maxWidth:700}}>
        📋 Output: SKU × Platform grid — Units, Sales(₹), AOV · Best platform highlighted · Amazon: Shipped only · Meesho: Shipped+Delivered+RTS
      </div>
      <div style={{display:"flex",justifyContent:"center",gap:12,marginBottom:16}}>
        <button style={{...S.btn,background:"linear-gradient(135deg,#935116,#E67E22)",...((!files.amazon.length&&!files.meesho.length)||status==="loading"?{opacity:0.4,cursor:"not-allowed"}:{})}} onClick={go} disabled={(!files.amazon.length&&!files.meesho.length)||status==="loading"}>
          {status==="loading"?"⟳ Comparing...":"🏪 Compare & Download"}
        </button>
        {(status==="done"||status==="error")&&<button style={S.ghost} onClick={()=>{setFiles({amazon:[],meesho:[],flipkart:[]});setStatus("idle");setLog([]);}}>Start Over</button>}
      </div>
      <LogBox log={log}/>
    </ToolPage>
  );
}


// ─── MODEL SWITCHER ──────────────────────────────────────────────────────────
function ModelSwitcher() {
  const [model,setModel]=useState("gemini-1.5-flash");
  const [saving,setSaving]=useState(false);
  useEffect(()=>{ fetch("/api/admin/model").then(r=>r.json()).then(d=>setModel(d.model)).catch(()=>{}); },[]);
  const change=async(m)=>{
    setSaving(true);
    await fetch("/api/admin/model",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({model:m})});
    setModel(m); setSaving(false);
  };
  return (
    <div style={{background:"rgba(155,89,182,0.08)",border:"1px solid rgba(155,89,182,0.2)",borderRadius:12,padding:"16px",marginBottom:20}}>
      <div style={{color:"#e8edf5",fontWeight:700,fontSize:14,marginBottom:12}}>🤖 AI Model Selection</div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        {[["gemini-1.5-flash","Gemini 1.5 Flash","Cheapest — ~90% less cost","#27AE60"],
          ["gemini-2.0-flash","Gemini 2.0 Flash","Balanced","#F39C12"],
          ["gemini-2.5-flash","Gemini 2.5 Flash","Best Quality — highest cost","#E74C3C"]].map(([id,label,desc,color])=>(
          <button key={id} onClick={()=>change(id)} disabled={saving}
            style={{flex:1,minWidth:160,padding:"12px",borderRadius:10,border:`2px solid ${model===id?color:"rgba(255,255,255,0.1)"}`,
              background:model===id?`${color}18`:"transparent",cursor:"pointer",textAlign:"left"}}>
            <div style={{color:model===id?color:"#e8edf5",fontWeight:700,fontSize:13}}>{label}{model===id?" ✓":""}</div>
            <div style={{color:"#8899aa",fontSize:11,marginTop:3}}>{desc}</div>
          </button>
        ))}
      </div>
      {saving&&<div style={{color:"#F39C12",fontSize:12,marginTop:8}}>⟳ Saving...</div>}
    </div>
  );
}

// ─── ADMIN PANEL ────────────────────────────────────────────────────────────────
function AdminPanel({session,onBack}) {
  const [tab,setTab]=useState("users");
  const [users,setUsers]=useState([]);const [allUsage,setAllUsage]=useState({byUser:[],total:{}});
  const [newUser,setNewUser]=useState({username:"",password:"",role:"user"});const [saving,setSaving]=useState(false);const [editingTools,setEditingTools]=useState(null);
  const [changingPwd,setChangingPwd]=useState(null);

  useEffect(()=>{
    fetch("/api/admin/users").then(r=>r.json()).then(setUsers).catch(()=>{});
    fetch("/api/usage-all").then(r=>r.json()).then(setAllUsage).catch(()=>{});
  },[]);

  const saveUser=async()=>{
    if(!newUser.username||!newUser.password)return;setSaving(true);
    await fetch("/api/admin/users",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(newUser)});
    const d=await fetch("/api/admin/users").then(r=>r.json());setUsers(d);
    setNewUser({username:"",password:"",role:"user"});setSaving(false);
  };

  const toggleActive=async(username,active)=>{
    await fetch(`/api/admin/users/${username}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({active:active?1:0})});
    const d=await fetch("/api/admin/users").then(r=>r.json());setUsers(d);
  };

  const delUser=async(username)=>{
    if(!window.confirm(`Delete user ${username}?`))return;
    await fetch(`/api/admin/users/${username}`,{method:"DELETE"});
    const d=await fetch("/api/admin/users").then(r=>r.json());setUsers(d);
  };

  return (
    <div style={S.root}>
      <div style={S.gridBg}/>
      <div style={S.wrap}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <button style={S.ghost} onClick={onBack}>← Dashboard</button>
            <div style={{display:"inline-block",padding:"5px 14px",borderRadius:20,background:"rgba(231,76,60,0.15)",border:"1px solid rgba(231,76,60,0.3)",color:"#E74C3C",fontSize:11,fontWeight:600,letterSpacing:1,textTransform:"uppercase"}}>👑 Admin Panel</div>
          </div>
          <span style={{color:"#8899aa",fontSize:13}}>👤 {session.username}</span>
        </div>

        {/* DB Mode Banner */}
        <div style={{background:session.dbMode==="full"?"rgba(39,174,96,0.08)":"rgba(243,156,18,0.08)",border:`1px solid ${session.dbMode==="full"?"rgba(39,174,96,0.2)":"rgba(243,156,18,0.2)"}`,borderRadius:10,padding:"10px 16px",marginBottom:24,fontSize:13,color:session.dbMode==="full"?"#27AE60":"#F39C12"}}>
          {session.dbMode==="full"?"🟢 Database Connected — Full admin features available":"🟡 Lite Mode — Database unavailable. User changes won't persist across restarts."}
        </div>

        {/* Tabs */}
        <div style={{display:"flex",gap:8,marginBottom:24}}>
          {[["users","👥 Users"],["usage","📊 Usage & Cost"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)} style={{padding:"8px 18px",borderRadius:20,border:"1px solid",cursor:"pointer",fontSize:13,fontWeight:600,background:tab===id?"rgba(231,76,60,0.2)":"rgba(255,255,255,0.04)",borderColor:tab===id?"#E74C3C":"rgba(255,255,255,0.1)",color:tab===id?"#E74C3C":"#8899aa"}}>{label}</button>
          ))}
        </div>

        {tab==="users"&&(
          <>
            {/* Add user */}
            <div style={{...S.card,marginBottom:20,maxWidth:600}}>
              <div style={{color:"#e8edf5",fontWeight:700,fontSize:14,marginBottom:14}}>➕ Add New User</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr auto auto",gap:10,alignItems:"end"}}>
                <div>
                  <label style={{display:"block",color:"#8899aa",fontSize:11,marginBottom:4}}>Username</label>
                  <input style={S.input} placeholder="username" value={newUser.username} onChange={e=>setNewUser(p=>({...p,username:e.target.value}))}/>
                </div>
                <div>
                  <label style={{display:"block",color:"#8899aa",fontSize:11,marginBottom:4}}>Password</label>
                  <input style={S.input} placeholder="password" value={newUser.password} onChange={e=>setNewUser(p=>({...p,password:e.target.value}))}/>
                </div>
                <div>
                  <label style={{display:"block",color:"#8899aa",fontSize:11,marginBottom:4}}>Role</label>
                  <select style={{...S.input,width:"auto"}} value={newUser.role} onChange={e=>setNewUser(p=>({...p,role:e.target.value}))}>
                    <option value="user">User</option><option value="admin">Admin</option>
                  </select>
                </div>
                <button style={{...S.btn,background:"linear-gradient(135deg,#922B21,#E74C3C)",padding:"10px 16px",opacity:saving?0.6:1}} onClick={saveUser} disabled={saving}>
                  {saving?"⟳":"Add"}
                </button>
              </div>
            </div>

            {/* User list */}
            <div style={S.card}>
              <div style={{color:"#e8edf5",fontWeight:700,fontSize:14,marginBottom:14}}>👥 Users ({users.length})</div>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  <tr>{["Username","Role","Status","Created","Actions"].map(h=>(
                    <th key={h} style={{padding:"8px 10px",background:"rgba(231,76,60,0.1)",color:"#c9a8f0",fontWeight:600,borderBottom:"1px solid rgba(255,255,255,0.08)",textAlign:"left"}}>{h}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {users.map((u,i)=>(
                    <tr key={u.username||i} style={{borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                      <td style={{padding:"8px 10px",color:"#e8edf5",fontWeight:600}}>{u.username}</td>
                      <td style={{padding:"8px 10px"}}><span style={{color:u.role==="admin"?"#E74C3C":"#4A9FD4",fontWeight:600}}>{u.role==="admin"?"👑 Admin":"👤 User"}</span></td>
                      <td style={{padding:"8px 10px"}}><span style={{color:u.active?"#27AE60":"#E74C3C",fontWeight:600}}>{u.active?"● Active":"● Inactive"}</span></td>
                      <td style={{padding:"8px 10px",color:"#667788"}}>{u.created_at?new Date(u.created_at).toLocaleDateString("en-GB"):"-"}</td>
                      <td style={{padding:"8px 10px"}}>
                        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                          <button onClick={()=>toggleActive(u.username,!u.active)} style={{background:u.active?"rgba(231,76,60,0.15)":"rgba(39,174,96,0.15)",border:`1px solid ${u.active?"rgba(231,76,60,0.3)":"rgba(39,174,96,0.3)"}`,borderRadius:5,color:u.active?"#E74C3C":"#27AE60",cursor:"pointer",fontSize:10,padding:"3px 8px"}}>
                            {u.active?"Disable":"Enable"}
                          </button>
                          <button onClick={()=>setEditingTools(editingTools===u.username?null:u.username)}
                            style={{background:"rgba(74,159,212,0.15)",border:"1px solid rgba(74,159,212,0.3)",borderRadius:5,color:"#4A9FD4",cursor:"pointer",fontSize:10,padding:"3px 8px"}}>
                            🔧 Tools
                          </button>
                          <button onClick={()=>setChangingPwd(changingPwd===u.username?null:u.username)}
                            style={{background:"rgba(243,156,18,0.15)",border:"1px solid rgba(243,156,18,0.3)",borderRadius:5,color:"#F39C12",cursor:"pointer",fontSize:10,padding:"3px 8px"}}>
                            🔑 Password
                          </button>
                          {u.username!=="admin"&&<button onClick={()=>delUser(u.username)} style={{background:"rgba(231,76,60,0.1)",border:"1px solid rgba(231,76,60,0.2)",borderRadius:5,color:"#E74C3C",cursor:"pointer",fontSize:10,padding:"3px 8px"}}>Delete</button>}
                        </div>
                        {changingPwd===u.username&&(
                          <div style={{gridColumn:"1/-1",background:"rgba(243,156,18,0.08)",border:"1px solid rgba(243,156,18,0.2)",borderRadius:8,padding:"10px",marginTop:6,display:"flex",gap:8,alignItems:"center"}}>
                            <input style={{...S.input,flex:1,fontSize:12,padding:"6px 10px"}} type="password" placeholder="New password"
                              id={`pwd_${u.username}`}/>
                            <button onClick={async()=>{
                              const pwd=document.getElementById(`pwd_${u.username}`).value;
                              if(!pwd)return;
                              await fetch("/api/admin/change-password",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({username:u.username,newPassword:pwd})});
                              setChangingPwd(null);
                              alert(`Password changed for ${u.username}`);
                            }} style={{...S.btn,background:"linear-gradient(135deg,#935116,#F39C12)",padding:"7px 14px",fontSize:11}}>
                              Save
                            </button>
                            <button onClick={()=>setChangingPwd(null)} style={{...S.ghost,fontSize:11,padding:"6px 10px"}}>Cancel</button>
                          </div>
                        )}
                        {editingTools===u.username&&(
                          <div style={{gridColumn:"1/-1",background:"rgba(74,159,212,0.08)",border:"1px solid rgba(74,159,212,0.2)",borderRadius:8,padding:"10px",marginTop:6}}>
                            <div style={{color:"#4A9FD4",fontSize:11,fontWeight:600,marginBottom:8}}>Tool Access for {u.username} (leave all off = access to all)</div>
                            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                              {TOOLS.filter(t=>t.available).map(t=>{
                                const access = u.tool_access ? JSON.parse(typeof u.tool_access==="string"?u.tool_access:"[]") : [];
                                const hasAccess = !access.length || access.includes(t.id);
                                return (
                                  <button key={t.id} onClick={async()=>{
                                    let cur = u.tool_access ? JSON.parse(typeof u.tool_access==="string"?u.tool_access:"[]") : [];
                                    if(!cur.length) cur = TOOLS.filter(t=>t.available).map(t=>t.id);
                                    if(cur.includes(t.id)) cur=cur.filter(x=>x!==t.id);
                                    else cur=[...cur,t.id];
                                    await fetch(`/api/admin/users/${u.username}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({tool_access:JSON.stringify(cur)})});
                                    const d=await fetch("/api/admin/users").then(r=>r.json());setUsers(d);
                                  }} style={{padding:"3px 10px",borderRadius:12,border:`1px solid ${hasAccess?"rgba(39,174,96,0.4)":"rgba(255,255,255,0.1)"}`,background:hasAccess?"rgba(39,174,96,0.15)":"rgba(255,255,255,0.04)",color:hasAccess?"#27AE60":"#667788",cursor:"pointer",fontSize:10}}>
                                    {t.icon} {t.name}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {tab==="usage"&&(
          <>
            {/* Global total */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
              {[
                {label:"Total API Calls",value:(allUsage.total?.calls||0).toLocaleString(),color:"#4A9FD4"},
                {label:"Input Tokens",value:((allUsage.total?.ti||0)).toLocaleString(),color:"#27AE60"},
                {label:"Output Tokens",value:((allUsage.total?.to2||0)).toLocaleString(),color:"#F39C12"},
                {label:"Total Cost",value:`₹${parseFloat(allUsage.total?.cost||0).toFixed(4)}`,color:"#E74C3C"},
              ].map(({label,value,color})=>(
                <div key={label} style={{background:`${color}10`,border:`1px solid ${color}33`,borderRadius:12,padding:"16px",textAlign:"center"}}>
                  <div style={{color,fontSize:22,fontWeight:800,marginBottom:4}}>{value}</div>
                  <div style={{color:"#8899aa",fontSize:12}}>{label}</div>
                </div>
              ))}
            </div>

            {/* Per user */}
            <div style={S.card}>
              <div style={{color:"#e8edf5",fontWeight:700,fontSize:14,marginBottom:14}}>📊 Usage by User</div>
              {allUsage.byUser.length===0?(
                <div style={{color:"#667788",fontSize:13}}>No usage data yet.</div>
              ):(
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                  <thead>
                    <tr>{["User","Calls","Input Tokens","Output Tokens","Cost (₹)","Last Used"].map(h=>(
                      <th key={h} style={{padding:"8px 10px",background:"rgba(74,159,212,0.1)",color:"#8BB8D4",fontWeight:600,borderBottom:"1px solid rgba(255,255,255,0.08)",textAlign:h==="User"?"left":"center"}}>{h}</th>
                    ))}</tr>
                  </thead>
                  <tbody>
                    {allUsage.byUser.map((u,i)=>(
                      <tr key={u.username||i} style={{borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                        <td style={{padding:"8px 10px",color:"#4A9FD4",fontWeight:600}}>{u.username}</td>
                        <td style={{padding:"8px 10px",color:"#e8edf5",textAlign:"center"}}>{(u.calls||0).toLocaleString()}</td>
                        <td style={{padding:"8px 10px",color:"#e8edf5",textAlign:"center"}}>{(u.input_tokens||0).toLocaleString()}</td>
                        <td style={{padding:"8px 10px",color:"#e8edf5",textAlign:"center"}}>{(u.output_tokens||0).toLocaleString()}</td>
                        <td style={{padding:"8px 10px",color:"#F39C12",fontWeight:700,textAlign:"center"}}>₹{parseFloat(u.cost_inr||0).toFixed(4)}</td>
                        <td style={{padding:"8px 10px",color:"#667788",textAlign:"center"}}>{u.last_used?new Date(u.last_used).toLocaleDateString("en-GB"):"-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─── ROOT ───────────────────────────────────────────────────────────────────────
export default function App() {
  const [session,setSession]=useState(null);
  const [screen,setScreen]=useState("dashboard");
  const [dbChecked,setDbChecked]=useState(false);

  // Check DB on load
  useEffect(()=>{
    fetch("/api/db-status").then(r=>r.json()).then(d=>{
      if(!d.available){
        const proceed=window.confirm("⚠️ Database is unavailable.\n\nData will not be saved across sessions.\n\nClick OK to continue in Lite Mode.");
        if(!proceed) return; // stay on blank screen
      }
      setDbChecked(true);
    }).catch(()=>setDbChecked(true));
  },[]);

  if(!dbChecked) return <div style={{minHeight:"100vh",background:"#0a0f1e",display:"flex",alignItems:"center",justifyContent:"center",color:"#4A9FD4",fontSize:14}}>Connecting...</div>;

  const handleLogin = s => { setSession(s); setScreen("dashboard"); };
  const handleLogout = () => { setSession(null); setScreen("dashboard"); };

  if (!session) return <LoginPage onLogin={handleLogin}/>;
  if (screen==="admin"   ) return <AdminPanel    session={session} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="amazon"  ) return <AmazonTool    user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="meesho"  ) return <MeeshoTool    user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="state"   ) return <StateTool     user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="keywords") return <KeywordsTool  user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="bulk"    ) return <BulkTool      user={session.username} session={session} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="overlap" ) return <OverlapTool   user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="images"  ) return <ImageTool     user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="listing" ) return <ListingTool   user={session.username} session={session} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="audit"      ) return <AuditTool      user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="sku_econ"   ) return <SkuEconTool    user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="sales"      ) return <SaleStore      user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="campaign_ai") return <CampaignAI     user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="flipkart"   ) return <FlipkartTool   user={session.username} onBack={()=>setScreen("dashboard")}/>;
  if (screen==="marketplace") return <MarketplaceTool user={session.username} onBack={()=>setScreen("dashboard")}/>;
  return <Dashboard session={session} onSelect={setScreen} onLogout={handleLogout}/>;
}
